import { __assign, __rest } from "tslib";
export * from './types';
export var readAsList = function (_a) {
    var data = _a.data, included = _a.included, meta = _a.meta;
    var entities = {};
    var readEntity = function (_a) {
        var _b, _c;
        var _d;
        var attributes = _a.attributes, relationships = _a.relationships, resourceIdentifier = __rest(_a, ["attributes", "relationships"]);
        // @ts-ignore
        (_b = entities[_d = resourceIdentifier.type]) !== null && _b !== void 0 ? _b : (entities[_d] = []);
        var entity = __assign(__assign(__assign({}, resourceIdentifier), attributes), { relationships: Object.keys(relationships).reduce(function (acc, key) {
                var _a;
                return __assign(__assign({}, acc), (_a = {}, _a[key] = relationships[key].data, _a));
            }, {}) });
        // @ts-ignore
        (_c = entities[resourceIdentifier.type]) === null || _c === void 0 ? void 0 : _c.push(entity);
    };
    data.forEach(readEntity);
    included.forEach(readEntity);
    return {
        entities: entities,
        meta: meta,
    };
};
